import React, { useState } from "react";
import { Button, Modal, Space, TabsProps } from "antd";
import styles from "../../styles/dialog.module.scss";
import Dropdown from "antd/es/dropdown/dropdown";
import { CaretDownOutlined } from "@ant-design/icons";

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  statusKey: string;
  onCancel: () => void;
  onOk: () => void;
  onSave: (value: string) => void;
  menuProps: {
    items: TabsProps["items"];
  };
}

const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  onClose,
  onSave,
  statusKey,
  onCancel,
  onOk,
  menuProps,
}) => {
  const [selectedValue, setSelectedValue] = useState(statusKey);

  return (
    <>
      <Modal
        open={isOpen}
        title={<span className={styles.title}>Change status</span>}
        onOk={onOk}
        onCancel={onCancel}
        width={480}
        footer={[
          <div key="footer" className={styles.footer}>
            <Button
              className={styles.cancel}
              key="cancel"
              style={{}}
              type="default"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              className={styles.save}
              type="primary"
              onClick={() => {
                onSave(selectedValue);
                onClose();
              }}
            >
              Save
            </Button>
          </div>,
        ]}
      >
        <Dropdown
          menu={{
            ...menuProps,
            selectedKeys: [selectedValue],
            onClick: ({ key }) => {
              key !== 'DONE' && setSelectedValue(key)
            },
          }}
        >
          <Button className={styles.dropdown}>
            <Space className={styles.selected}>
              {
                menuProps?.items?.find(
                  (item) => item.key == (selectedValue || statusKey),
                )?.label
              }
              <CaretDownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Modal>
    </>
  );
};

export default StatusModal;
